import ApiConnector from './ApiConnector';
import Constants from 'config/Constants';
import { getEnv } from 'config/Env';
import ApiConnector_v2 from './ApiConnector_v2';
import baseAPI from './ApiConnector_v2';

const apiBaseUrl = getEnv('REIMBURSEMENT_API_BASE_URL');
const apiUrl = getEnv('REIMBURSEMENT_API_URL');
const uriPrefix = '/api/reimbursement-api';

function prepareFormData(formData) {
    const propsWithPrefix = ['category', 'parent'];

    propsWithPrefix.forEach((propName) => {
        if (
            formData.hasOwnProperty(propName) &&
            formData[propName] !== null &&
            formData[propName].startsWith(uriPrefix) === false
        ) {
            formData[propName] = uriPrefix + formData[propName];
        }
    });

    return formData;
}

const ReimbursementApi = {
    batchEdit(formData) {
        return baseAPI.post(apiUrl + '/batch_edits', formData);
    },
    createCrossRefMigrationTask(formData) {
        return ApiConnector_v2.post(apiUrl + '/cross_ref_migration_tasks', formData);
    },
    createProductType(formData) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiPost(apiUrl + '/product_types', prepareFormData(formData))
                .then((result) => resolve(result))
                .catch((context) => reject(context));
        });
    },
    createReimbursementCode(formData) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiPost(apiUrl + '/reimbursement_codes', formData)
                .then((result) => resolve(result))
                .catch((context) => reject(context));
        });
    },
    createReimbursementCodeTranslation(formData) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiPost(apiUrl + '/reimbursement_code_translations', formData)
                .then((result) => resolve(result))
                .catch((context) => reject(context));
        });
    },
    updateProductType(id, formData) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiPut(apiUrl + '/product_types/' + id, formData)
                .then((result) => resolve(result))
                .catch((context) => reject(context));
        });
    },
    updateReimbursementCode(id, formData) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiPut(apiUrl + '/reimbursement_codes/' + id, formData)
                .then((result) => resolve(result))
                .catch((context) => reject(context));
        });
    },
    updateReimbursementCodeTranslation(id, formData) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiPut(apiUrl + '/reimbursement_code_translations/' + id, formData)
                .then((result) => resolve(result))
                .catch((context) => {
                    getEnv('APP_ENV') === Constants.environments.dev &&
                        console.log('unable to update translations', context);
                    reject(context);
                });
        });
    },
    deleteReimbursementCode(id) {
        return ApiConnector.apiDelete(`${apiUrl}/reimbursement_codes/${id}`);
    },
    get(id, idIsUri = false) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiGet((idIsUri ? apiBaseUrl : apiUrl) + id)
                .then((result) => resolve(result))
                .catch((context) => {
                    getEnv('APP_ENV') === Constants.environments.dev && console.log('unable to get data', context);
                    reject(context);
                });
        });
    },
    getProductTypes(categoryId) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiGet(apiUrl + '/categories/' + categoryId + '/product_types')
                .then((result) => resolve(result))
                .catch((context) => {
                    getEnv('APP_ENV') === Constants.environments.dev && console.log('unable to load products', context);
                    reject(context);
                });
        });
    },
    getReimbursementCodes(categoryId) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiGet(apiUrl + '/categories/' + categoryId + '/reimbursement_codes')
                .then((result) => resolve(result))
                .catch((context) => {
                    getEnv('APP_ENV') === Constants.environments.dev &&
                        console.log('unable to load reimbursement codes', context);
                    reject(context);
                });
        });
    },
    getReimbursementCodeTranslations(codeId) {
        return new Promise((resolve, reject) => {
            ApiConnector.apiGet(apiUrl + '/reimbursement_codes/' + codeId + '/translations')
                .then((result) => resolve(result))
                .catch((context) => {
                    getEnv('APP_ENV') === Constants.environments.dev &&
                        console.log('unable to load translations', context);
                    reject(context);
                });
        });
    },
};

export default ReimbursementApi;
